'use strict';

var angular = require('angular');
var SponsorshipPanelDirective = function SponsorshipPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/sponsorship-panel.html'),
    controller: 'SponsorshipPanelController',
    link: function link(scope, element) {
      scope.togglePanel = function (show) {
        scope.expanded = show;
        element.find('#' + scope.uniqueId).collapse(show ? 'show' : 'hide');
      };
      scope.collapse = scope.togglePanel.bind(scope, false);
      scope.uncollapse = scope.togglePanel.bind(scope, true);
      scope.$on('hide.sponsor.dropdown', function (e, visibleDropdown) {
        angular.element(visibleDropdown).removeClass('open');
      });
    }
  };
};
SponsorshipPanelDirective.$inject = [];
module.exports = SponsorshipPanelDirective;